
import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslationService } from '../services/translation.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { DecimalPipe } from '@angular/common';

@Injectable()
export class MatPaginatorIntlImpl extends MatPaginatorIntl {

    ofLabel: string;

    constructor(private translatePipe: TranslatePipe, private translationService: TranslationService, private decimalPipe: DecimalPipe) {
        super();
        this.translationService.userLocaleSubject.subscribe((locale) => {
            this.setLabels();
        });
        this.translationService.translationsSubject.subscribe((locale) => {
            this.setLabels();
        });
    }

    setLabels(): void {
        setTimeout(() => {//timeout to wait for changes because it still has old translation locale value
            this.itemsPerPageLabel = this.translatePipe.getLabel("recordsPerPage");
            this.nextPageLabel = this.translatePipe.getLabel("next");
            this.previousPageLabel = this.translatePipe.getLabel("previous");
            this.firstPageLabel = this.translatePipe.getLabel("first");
            this.lastPageLabel = this.translatePipe.getLabel("last");
            this.ofLabel = this.translatePipe.getLabel("of");
            this.changes.next();
        }, 0);
    }

    /**
     * implementation is same as parent
     * @param page 
     * @param pageSize 
     * @param length 
     */
    getRangeLabel = function (page: number, pageSize: number, length: number): string {
        length = Math.max(length, 0);
        let formattedLength = this.decimalPipe.transform(length, '1.0-0');
        if (length == 0 || pageSize == 0) {
            return `0 ${this.ofLabel} ${formattedLength}`;
        }
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        let formattedStartIndex = this.decimalPipe.transform(startIndex + 1, '1.0-0');
        let formattedEndIndex = this.decimalPipe.transform(endIndex, '1.0-0');

        return `${formattedStartIndex} – ${formattedEndIndex} ${this.ofLabel} ${formattedLength}`;
    }

}